import { connect } from 'react-redux';
import ProjectedSpotsConfirmation from './ProjectedSpotsConfirmation';

const mapStateToProps = (_, ownProps) => {
  const { networkCap, schedule } = ownProps;
  const { spots } = schedule;
  const { classpassTotal: currentClasspassTotal, smartspotRecommendedSpots } = spots || {};
  return {
    difference:
      smartspotRecommendedSpots && networkCap < smartspotRecommendedSpots
        ? smartspotRecommendedSpots - networkCap
        : null,
    isDecrease: networkCap < currentClasspassTotal,
    networkCap,
    smartspotRecommendedSpots,
  };
};

export default connect(mapStateToProps)(ProjectedSpotsConfirmation);
